import {
  externalConnectionCalendarsConverter,
  getExternalConnectionCalendarsDoc as _getExternalConnectionCalendarsDoc,
} from '@griply/services';
import { ExternalConnectionCalendarsCache } from '@griply/types';
import {
  doc,
  DocumentReference,
  Firestore,
  FirestoreDataConverter,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { getDatabase } from './helpers';

// cast: FirestoreDataConverter is invariant on the snapshot type the shared converter keeps structural
const converter =
  externalConnectionCalendarsConverter as unknown as FirestoreDataConverter<ExternalConnectionCalendarsCache>;

// getDatabase, not getFirestore — a pre-init getFirestore() would silently disable persistence app-wide
export const getExternalConnectionCalendarsDoc = (externalConnectionId: ID) =>
  _getExternalConnectionCalendarsDoc<DocumentReference, Firestore>({
    externalConnectionId,
    db: getDatabase(),
    doc,
  }).withConverter(converter);
